module.exports = __webpack_public_path__ + "static/index/img/baikal-602.fa8f7ed4.jpg";